import dayjs from 'dayjs';
import * as React from 'react';

import Tab, { Tabs } from '@/components/elements/Button/TabButton';
import DateSelector from '@/components/elements/DateSelector';
import { RaceType } from '@/modelTypes';

import { Headline } from '../style';
import { DateSelectorWrapper, TabWrapper } from './style';

export interface ResultsTemplateProps {
  date: dayjs.Dayjs;
  raceType: RaceType;
  setRaceType: React.Dispatch<React.SetStateAction<RaceType>>;
}

const ResultsTemplate: React.FC<
  ResultsTemplateProps & { children: React.ReactNode }
> = ({ date, raceType, setRaceType, children }) => {
  return (
    <>
      <Headline>レース結果</Headline>
      <TabWrapper>
        <Tabs>
          <Tab
            active={raceType === RaceType.Singlerace}
            onClick={() => setRaceType(RaceType.Singlerace)}
          >
            競輪投票
          </Tab>
          <Tab
            active={raceType === RaceType.Multirace}
            onClick={() => setRaceType(RaceType.Multirace)}
          >
            チャリロト・Dokanto!
          </Tab>
        </Tabs>
      </TabWrapper>
      <DateSelectorWrapper>
        <DateSelector
          date={date}
          displayFormat="YYYY年M月D日"
          pathFormat="YYYY-MM-DD"
          unit="day"
        />
      </DateSelectorWrapper>
      {children}
    </>
  );
};

export default ResultsTemplate;
